import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonComponent } from '../../components/button/button.component';
import { ButtonTypeEnum } from '../../components/button/types/button-type.enum';
import { ButtonSizeEnum } from '../../components/button/types/button-size.enum';
import { ButtonRadiusEnum } from '../../components/button/types/button-radius.enum';

export interface SuccessModalData {
  title?: string;
  subtitle?: string;
  imageAlt?: string;
  iconPath?: string;
  primaryButtonLabel?: string;
}

@Component({
  selector: 'l-success-modal',
  standalone: true,
  templateUrl: './success-modal.component.html',
  imports: [
    ButtonComponent,
  ],
})
export class SuccessModalComponent {

  constructor(
    private readonly ref: DynamicDialogRef,
    private readonly config: DynamicDialogConfig<SuccessModalData>,
  ) { }

  public readonly buttonTypeEnum: typeof ButtonTypeEnum = ButtonTypeEnum;

  public readonly buttonSizeEnum: typeof ButtonSizeEnum = ButtonSizeEnum;

  public readonly buttonRadiusEnum: typeof ButtonRadiusEnum = ButtonRadiusEnum;

  public get title(): string {
    return this.config.data?.title ?? 'Usuários importados com sucesso!';
  }

  public get subtitle(): string {
    return this.config.data?.subtitle ?? 'Você pode visualizar ou editar através da lista de usuários';
  }

  public get imageAlt(): string {
    return this.config.data?.imageAlt ?? 'Sucesso';
  }

  public get safeAlt(): string {
    const normalizedAlt = this.imageAlt.replaceAll(/\bimage\b/gi, '').trim();
    return normalizedAlt.length > 0 ? normalizedAlt : 'Sucesso';
  }

  public get iconPath(): string {
    return this.config.data?.iconPath ?? 'assets/icons/check.svg';
  }

  public get primaryButtonLabel(): string {
    return this.config.data?.primaryButtonLabel ?? 'Fechar';
  }

  public close(): void {
    this.ref.close({ reload: true });
  }

}
